type localeString = 'en' | 'en-au';

const ENDateFormat = {
  DAY_MONTH_TIME: 'LLLL dd, HH:mm:ss',
  DAY_MONTH_YEAR_NO_HYPHEN: 'MMMM$d$yyyy',
  DAY_MONTH_YEAR_TIME: 'MMMM $d$ yyyy, HH:mm:ss',
  ISO_8601: 'yyyy-MM-dd',
};

const ENAUDateFormat = {
  DAY_MONTH_TIME: 'dd LLLL, HH:mm:ss',
  DAY_MONTH_YEAR_NO_HYPHEN: '$d$MMMM yyyy',
  DAY_MONTH_YEAR_TIME: '$d$ MMMM yyyy, HH:mm:ss',
  ISO_8601: 'yyyy-MM-dd',
};

type localeFormatCollection = { [key: string]: string };

interface LocaleStore {
  formats: localeFormatCollection;
  locale: localeString;
}

const localeStore: LocaleStore = {
  formats: ENDateFormat,
  locale: 'en',
};

function Locale(locale: string) {
  localeStore.locale = locale as localeString;

  switch (locale) {
    case 'en':
      localeStore.formats = ENDateFormat;
      break;
    case 'en-au':
    case 'en-gb':
      localeStore.formats = ENAUDateFormat;
  }
}

export function localeFormats() {
  return localeStore.formats;
}

export default Locale;
